import React, { FC } from 'react'
import { HandleSearchIcon, SearchCloseIcon } from '../../../../constants/svg'
import { CardSearch } from '../style'

type SearchFilterData = {
  searchPlaceholder: string
  searchKeyword: string
  handleSearchChange: React.ChangeEventHandler<HTMLInputElement>
  handleKeyUp: React.KeyboardEventHandler<HTMLInputElement>
  closeIcon?: boolean
  clearSearch?: () => void
  handleSearch?: () => void
}

type searchFilterDataProps = {
  searchFilterData: SearchFilterData
}

const SearchFilters: FC<searchFilterDataProps> = ({ searchFilterData }) => {
  const {
    searchPlaceholder,
    searchKeyword,
    handleSearchChange,
    handleKeyUp,
    closeIcon,
    clearSearch,
    handleSearch,
  } = searchFilterData

  return (
    <CardSearch className="Card__Search">
      <input
        type="text"
        placeholder={searchPlaceholder}
        value={searchKeyword}
        onChange={handleSearchChange}
        onKeyUp={handleKeyUp}
      />
      {closeIcon && <SearchCloseIcon clearSearch={clearSearch} />}
      {handleSearch && <HandleSearchIcon handleSearch={handleSearch} />}
    </CardSearch>
  )
}

export default SearchFilters
